// ******************************************************************************************
// PAGE STYLE & LAYOUT
export const gridBackgroundStyle = { position: "fixed", left: 0, top: 0, bottom: 0, zIndex: -1, width: "100%", height: "100vh", backgroundImage: 'url("/image/background-grid.png")', backgroundAttachment: "fixed" }

export const hiddenCanvas = { position: 'absolute', top: 0, bottom: 0, left: 0, right: 0, overflow: 'hidden' }

// Modal
export const modal = {
    modalTabContents: {
        height: 460, overflow: 'scroll'
    }
}
 
//Navbar
export const toolbar = {
    toolbarContainer: {
        minHeight: 60,  display: "flex", justifyContent: "space-between", boxShadow: 'none', backgroundColor: 'white',
        borderBottom: `1px solid #e5e7eb`,
        // boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.06)'
    },
    toolbarActionIcon: {
        marginLeft: 10, height: 25
    },
    toolbarActionIconContainer: {
        display: 'flex',
        alignItems: 'center',
        height: "100%",
        justifyContent: 'flex-start',
        margin: "2.5px",
        paddingBottom: 0.5
    },
    toolbarCentralGroup: {
        display: 'flex',
        alignItems: 'center',
        // backgroundColor: '#f3f4f6', // bg-gray-100
        padding: 10,             // p-1
        borderRadius: '12px',       // rounded-xl
        boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.1), inset 0 1px 2px 0 rgba(0, 0, 0, 0.06)', // shadow-inner
        border: '1px solid #e5e7eb', // border border-gray-200
    }
}

// ******************************************************************************************
// Projects page
export const projectStyle = {
    container: {
        slimFormContainer: {
            margin: 0,
            padding: 0
        },
        loadingSpinnerContainer: {
            width: "50px",
            height: "50px"
        },
        projectScreenshotContainer: {
            overflow: "hidden",
            position: "relative",
            width: "100%",
            height: 150,
            top: 0,
            left: 0
        }
    },
    box: {
        projectScreenshotBox: {
            top: 0,
            left: 0,
            width: "250",
            height: "150",
            overflow: "hidden"
        },
        projectTextBox: {
            width: "100%",
            margin: 10
        }
    },
    projectButton: {
        newProjectButton: {
            active: {
                backgroundColor: "#FAC710",
                boxShadow: "none",
                color: 'black',
                borderRadius: 0,
                borderStyle: "outset",
                padding: 10
            },
            disabled: { 
                backgroundColor: "grey",
                boxShadow: "none",
                color: 'white',
                borderRadius: 0,
                borderStyle: "outset",
                padding: 10
            }
        },
        editProjectButton: {
            width: '60%',
            margin: 10,
            inline: true,
            backgroundColor: 'black',
            borderRadius: 32
        },
        upgradePlaceholderButton: {
            width: '60%',
            margin: 10,
            inline: true,
            backgroundColor: 'gray',
            borderRadius: 32
        }
    },
}

// ******************************************************************************************
// Editor
export const editor = {
    // SIDEBAR
    sidebarAccordion: {
        opacity: 0.5,
        height: "100%",
        top: 0,
        right: 280,
        position: 'absolute',
    },
    sidebarContainer: {
        height: "100vh", gap: 0, justifyContent: 'space-between'
    },
    sidebarSection: {
        overflowY: "scroll",
        scrollbarWidth: 'none',
        // boxShadow: 'inset 0 -10px 10px -10px rgba(0, 0, 0, 0.5)'
    },
    sidebarIcon: {
        width: '16px', height: '16px', borderBottom: '#F9F9F9', marginRight: 5
    },
    modelAccordion: {
        width: 15, position: "absolute", top: 20, right: 285
    },
    sidebarOthersContainer: {
        width: "100%", paddingRight: 15, padding: 5, marginLeft: 5, marginTop: 10
    },
    sidebarOthersUsers: {
        overflowY: "scroll", overflowX: "hidden",
        scrollbarWidth: 'none',
        // backgroundColor: '#f3f4f6', 
        borderRadius: '12px',       // rounded-xl
        boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.1), inset 0 1px 2px 0 rgba(0, 0, 0, 0.06)', // shadow-inner
        border: '1px solid #e5e7eb', // border border-gray-200
    },
    sidebarToggleButton: {
        height: 25, borderRadius: 30, paddingLeft: 1, paddingRight: 1, paddingTop: 1, paddingBottom: 1, fontSize: 12, color: '#868e96', borderWidth: 1.5
    },

    // ARTBOARD PANEL
    artboardTopLevelContainer: {
        width: "100%", height:'100%'
    },
    artboardCard: { borderRadius: 16, cursor: 'pointer' },
    artboardCardContents: { position: "absolute"},
    artboardViewingScreenshot: { width: 120, height: 85 },
    artboardNotViewingScreenshot: { width: 120, height: 85, borderRadius: 0, backgroundColor: '#C1C2C5' },
    artboardNameText: { textOverflow: 'ellipsis', overflow: "hidden", whiteSpace: 'nowrap', marginBottom: 10, width: 95 },
    artboardActionIcon: { marginRight: 10, height: 20, width: 20 }

}
